var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-layout"},[(_vm.canShowNavigation)?[_c('AppBar')]:_vm._e(),_vm._t("default"),(_vm.canShowNavigation)?[_c('AppFooter')]:_vm._e(),_c('EmailConfirmationRequiredModal')],2)}
var staticRenderFns = []

export { render, staticRenderFns }